/**
 * Logger Service per gestione centralizzata dei log
 * Evita l'esposizione di dati sensibili in produzione
 */

class Logger {
  private isDevelopment = process.env.NODE_ENV === 'development';

  /**
   * Log generale (solo in development)
   */
  log(...args: any[]): void {
    if (this.isDevelopment) {
      console.log(...args);
    }
  }

  /**
   * Log di warning (solo in development)
   */
  warn(...args: any[]): void {
    if (this.isDevelopment) {
      console.warn(...args);
    }
  }

  /**
   * Log di errore (sempre attivo per ora, sarà sostituito con error tracking)
   */
  error(...args: any[]): void {
    // In produzione useremo Sentry o altro servizio
    console.error(...args);
  }

  /**
   * Log di debug (solo in development)
   */
  debug(...args: any[]): void {
    if (this.isDevelopment) {
      console.debug(...args);
    }
  }

  /**
   * Log di informazioni (solo in development)
   */
  info(...args: any[]): void {
    if (this.isDevelopment) {
      console.info(...args);
    }
  }
}

// Singleton instance
const logger = new Logger();

export default logger;